"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.table.shortcut': 'Atajo',
    'shortcuts.table.description': 'Descripción',
};
